@if (visning() == 'liste') {
  <ng-container *ngTemplateOutlet="listevisningFragment"/>
} @else {
  <ng-container *ngTemplateOutlet="kortvisningFragment"/>
}

@if (sorteringEndret()) {
  <div class="handlinger" navigasjonforhindret-flash>
    <button mat-button color="primary" (click)="lagreNySortering()">
      <mat-icon>save</mat-icon>
      {{ 'Lagre ny dokumentrekkefølge'|translate }}
    </button>
    <button mat-button (click)="avbrytNySortering()">
      <mat-icon>cancel</mat-icon>
      {{ 'Avbryt'|translate }}
    </button>
  </div>
}

<!-- kort-visning av dokumenter -->
<ng-template #kortvisningFragment>
  <div class="kortvisning">
    @if (dokumenter().length > 0 || opplastinger().length > 0) {
      <div class="sorterings-kontainer" cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="dokumentFlyttet($event)">
        @for (dokument of dokumenter(); track dokument.id) {
          <dokument-kortvisning [dokumentversjon]="dokument" [class.valgt]="valgtDokument() == dokument" (enkeltklikk)="visDetaljerFor(dokument)" cdkDrag cdkDragPreviewContainer="parent"/>
        }
      </div>
        @for (opplasting of opplastinger(); track opplasting) {
          <dokument-opplasting-kortvisning [opplasting]="opplasting" (vedAvbryt)="opplasting.avbryt()" @fadeInnUt/>
        }
    }
  </div>
</ng-template>

<!-- liste-visning av dokumenter -->
<ng-template #listevisningFragment>
  <table class="listevisning">
    <tbody class="sorterings-kontainer" cdkDropList cdkDropListOrientation="vertical" (cdkDropListDropped)="dokumentFlyttet($event)">
    @for (dokument of dokumenter(); track dokument.id) {
      <dokument-listevisning [dokumentversjon]="dokument" [class.valgt]="valgtDokument() == dokument" (enkeltklikk)="visDetaljerFor(dokument)" cdkDrag cdkDragPreviewContainer="parent"/>
    }
    </tbody>
    <tbody>
      @for (opplasting of opplastinger(); track opplasting) {
        <dokument-opplasting-listevisning [opplasting]="opplasting" (vedAvbryt)="opplasting.avbryt()" @fadeInnUt/>
      }
    </tbody>
  </table>
</ng-template>
